"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLambdaAlarms = exports.serviceDefinition = exports.LambdaServiceDefinition = exports.defaultLambdaAlarms = void 0;
const Environment_1 = require("./Environment");
/** repeated to avoid importing aws-cdk */
const ComparisonOperator = {
    /**
     * Specified statistic is greater than or equal to the threshold
     */
    GREATER_THAN_OR_EQUAL_TO_THRESHOLD: 'GreaterThanOrEqualToThreshold',
    /**
     * Specified statistic is strictly greater than the threshold
     */
    GREATER_THAN_THRESHOLD: 'GreaterThanThreshold',
    /**
     * Specified statistic is strictly less than the threshold
     */
    LESS_THAN_THRESHOLD: 'LessThanThreshold',
    /**
     * Specified statistic is less than or equal to the threshold.
     */
    LESS_THAN_OR_EQUAL_TO_THRESHOLD: 'LessThanOrEqualToThreshold',
    /**
     * Specified statistic is lower than or greater than the anomaly model band.
     * Used only for alarms based on anomaly detection models
     */
    LESS_THAN_LOWER_OR_GREATER_THAN_UPPER_THRESHOLD: 'LessThanLowerOrGreaterThanUpperThreshold',
    /**
     * Specified statistic is greater than the anomaly model band.
     * Used only for alarms based on anomaly detection models
     */
    GREATER_THAN_UPPER_THRESHOLD: 'GreaterThanUpperThreshold',
    /**
     * Specified statistic is lower than the anomaly model band.
     * Used only for alarms based on anomaly detection models
     */
    LESS_THAN_LOWER_THRESHOLD: 'LessThanLowerThreshold',
};
const { region, accountId, projectCode, stage } = { ...Environment_1.Environment };
/**
 * 22 07 Reduce number of metrics
 */
exports.defaultLambdaAlarms = {
    // metricDuration: {
    //   evaluationPeriods: 10,
    //   threshold: 5000,
    //   comparisonOperator: ComparisonOperator.GREATER_THAN_OR_EQUAL_TO_THRESHOLD,
    //  },
    metricErrors: {
        evaluationPeriods: 1,
        threshold: 1,
        comparisonOperator: ComparisonOperator.GREATER_THAN_OR_EQUAL_TO_THRESHOLD,
    },
    // metricInvocations: {
    //   evaluationPeriods: 1,
    //   threshold: 500,
    //   comparisonOperator: ComparisonOperator.GREATER_THAN_OR_EQUAL_TO_THRESHOLD,
    // },
    // metricThrottles: {
    //   evaluationPeriods: 1,
    //   threshold: 1,
    //   comparisonOperator: ComparisonOperator.GREATER_THAN_OR_EQUAL_TO_THRESHOLD,
    // }
};
const LambdaServiceDefinition = () => {
    const { region, accountId, projectCode, stage } = process.env;
    return {
        entityState: {
            name: `${projectCode}-${stage}-EntityState`,
        },
        cloudwatchAlertsProcessEventBusEvent: {
            name: `${projectCode}-${stage}-cloudwatchAlerts-processEvent`,
        },
        deadLetterQueueReceiver: {
            name: `${projectCode}-${stage}-dead-letter-receiver`,
        },
        deviceControlController: {
            name: `${projectCode}-${stage}-device-control-controller`,
            alarmConfig: {
                metricErrors: {
                    evaluationPeriods: 1,
                    threshold: 1,
                    comparisonOperator: ComparisonOperator.GREATER_THAN_OR_EQUAL_TO_THRESHOLD,
                },
            },
        },
        deviceControlDeviceState: {
            name: `${projectCode}-${stage}-device-control-deviceState`,
        },
        networkData: {
            name: `${projectCode}-${stage}-NetworkData-Stack-Processor`,
        },
        subscriberNotification: {
            name: `${projectCode}-${stage}-subscriber-notification`,
        },
        notificationEmit: {
            name: `${projectCode}-${stage}-notification-emit`,
        },
        hotColdStorage: {
            name: `${projectCode}-${stage}-hotCold`,
        }
    };
};
exports.LambdaServiceDefinition = LambdaServiceDefinition;
/** stacks with bare name have logic to add projectCode and stage, due for change */
const stacks = {
    AthenaGlue: { name: `${projectCode}-${stage}-athena-glue`, description: "Configuration of Athena, Glue for BI usage", },
    AWS_LPNAS: { name: `${projectCode}-${stage}-aws-lpnas`, description: "Configuration of AWS LPNAS", },
    // CalculatedState: { name: `${ projectCode }-${ stage }-DynanoDB`, description: "Calculates entity states on incoming messages" },
    // temporarily out of order for clarity
    EntityState: { name: `${projectCode}-${stage}-EntityState`, description: "Calculates entity states on incoming messages" },
    EntityStateImage: { name: `${projectCode}-${stage}-EntityStateImage`, description: "Calculates entity states on incoming messages" },
    CloudWatchAlerts: { name: `${projectCode}-${stage}-CloudWatchAlerts`, description: "AWS generated alerts", },
    CognitoSetUp: { name: `${projectCode}-cognito-stack-${stage}`, description: "Defines the identity store behaviour and permissions granted to IoTV-defined user groups" },
    ConsumerDataAPI: { name: `${projectCode}-${stage}-consumer-data`, description: "REST API for external consumers, authorization by Cognito", },
    ConsumerDataIO: { name: `${projectCode}-${stage}-ConsumerDataIO`, description: "Handles Import/Export jobs to/from GSheets (via S3 buckets)", },
    DataAggregation: { name: "DataAggregation", description: "TODO: Unknown" },
    DeviceControl: { name: `${projectCode}-${stage}-DeviceControl-Stack`, description: "Handles requests to downlink to LoRa devices", },
    DeviceControlAPI: { name: `${projectCode}-${stage}-DeviceControlAPI-Stack`, description: "API for device control requests", },
    DeviceControlArbitration: { name: `${projectCode}-${stage}-DeviceControlArbitration-Stack`, description: "Preprocesses and arbitrates device control requests, eg evaluates for exiting (duplicate) requests", },
    DataLifecycleProcess: { name: `${projectCode}-${stage}-DataLifecycle`, description: "TODO: Unknown" },
    EFS: { name: `${projectCode}-${stage}-EFS-FS1`, description: "Shared file system FS1 for containers, etc.", },
    ExternalDNSandCloudfront: { name: `${projectCode}-${stage}-ExternalDNSandCloudfront`, description: "defines additional cloudfront distributions for UIs, certificates and adds to hosted zone in the account as based on project configs in @iotv/config", },
    FanOut: { name: `${projectCode}-${stage}-FanOut`, description: "Lamdba implementation of FanOut process. Consumes stream from DynamoDB and distributes to consumers", },
    FanOutImage: { name: `${projectCode}-${stage}-FanOutImage`, description: "Container Image invoking FanOut process, Consumes stream from DynamoDB and distributes to consumers", },
    HotColdLambda: { name: `${projectCode}-${stage}-HotColdLambda`, description: "Lambda implementation of code that polls redis for items ready to move from hot to cold storage, then executes move and settles with Redis", },
    IAM: { name: `${projectCode}-${stage}-IAM`, description: "Optional IAM entities, for example to allow quick resets to test user permissions", },
    IoTCoreSetUp: { name: `${projectCode}-${stage}-iot-core-stack`, description: "Sets up IoT Core for device messages from gateways and other MQTT-based messaging" },
    Kinesis: { name: `${projectCode}-${stage}-Kinesis`, description: "Allows dependency free definition of Kinesis streams", },
    LambdaLayer: { name: `${projectCode}-${stage}-DatastoreLayerStack`, description: "Holds common @iotv/ modules and enables access to the datastore, shared by other Lambda's" },
    LoggerLambda: { name: `${projectCode}-${stage}-LoggerLambda`, description: "Deploys Lambda that reads from log Kinesis stream and writes to S3 desinations", },
    MainTableSetUp: { name: `${projectCode}-${stage}-main-table-stack`, description: "Holds the main DynamoDB table datastore" },
    NetworkAPI: { name: `${projectCode}-${stage}-NetworkAPI`, description: "Network (gateway and device) data routing, aka ingestion api", },
    NetworkData: { name: `${projectCode}-${stage}-NetworkData`, description: "Network data (gateway and device) processing", },
    NetworkDataImage: { name: `${projectCode}-${stage}-NetworkDataImage`, description: "ECR Image for Container deployment: Network data (gateway and device) processing", },
    NotificationsSystem: { name: "Notifications", description: "Provides subscription evaluator, notification emitter", SubscribedNotifier: { name: "SubscribedNotifier", description: "Matches incoming incidents with notification subscriptions" }, NotificationEmit: { name: "NotificationEmit", description: "Sends emails, SMS messages, or mobile push notifications to users" }, },
    PlatformApplication: { name: `${projectCode}-${stage}-PlatformApplication`, description: "Deploys SNS Platform Applications to enable push messaging to mobile", },
    QuickSuite: { name: `${projectCode}-${stage}-QuickSuite`, description: "Partial service deployment and utility code for QuickSuite", },
    Route53: { name: `${projectCode}-${stage}-Route53`, description: "Creates hosted zone and certificates for an existing domain name in AWS", },
    S3: { name: `${projectCode}-${stage}-S3`, description: "Allows dependency free definition of S3 buckets", },
    ScheduledReports: { name: `${projectCode}-${stage}-ScheduledReports`, description: "Sends Scheduled Reports TODO", },
    SES: { name: `${projectCode}-${stage}-SES`, description: "Allows dependency free definition of SES constructs", },
    SQS: { name: `${projectCode}-${stage}-SQS`, description: "Allows dependency free definition of SQS queues", },
    SQSDeadLetters: { name: `${projectCode}-${stage}-SQSDeadLetters`, description: "General dead letters to S3 pattern", },
    SystemAlerts: { name: "Alerts", description: "Processes system-related issues and network/gateway/device AWOL's from Wideawake" },
    SystemManagementAPI: { name: "SystemManagementAPI", description: "Lambda Proxy API for managing system settings and configurations", },
    SystemSelfCheck: { name: `${projectCode}-${stage}-SystemSelfCheck`, description: "Lambda calling utilities which will report system status into S3 system bucket", },
    ThingAlerts: { name: "ThingAlerts", description: "Evaluates current state of Thing and creates an Alert if rules are violated", },
    Timestream: { name: `${projectCode}-${stage}-Timestream`, description: "Deploys Timestream tables", },
    UserAssetsS3Bucket: { name: `${projectCode}-${stage}-userblobs-${stage}`, description: "Bucket for user uploaded assets", },
    VPC: { name: `${projectCode}-${stage}-VPC`, description: "VPC for aws services", },
    WebsiteS3Buckets: { name: `${projectCode}-website-bucket-stack-${stage}`, description: "Deploys S3 buckets and associated CloudFront distributions for hosting the UI" },
    Wideawake: { name: `${projectCode}-${stage}-Wideawake`, description: "Deploys container with Node server that can be configured to continously monitor and report events", },
    WideawakeService: { name: `${projectCode}-${stage}-WideawakeService`, description: "Builds docker image for wideawake service and pushes to CDK ECR registry", },
};
exports.serviceDefinition = {
    IOTV_Stack: stacks,
    APIGateway: {
        apimqtt: {
            name: `${projectCode}-${stage}-api-mqtt`,
        },
        apiDynamoDB: {
            name: `${projectCode}-${stage}-api-dynamodb`,
        },
        // networkDAL: {
        //   name: `${projectCode}-${stage}-v3-1-DAL-API`
        // }
    },
    Cognito: {
        Userpool: [`${projectCode}-cognito-stack-${stage}-UserPool`],
        // there is a mismatch of _ and - for identity pools. The deployed  IdentityPoolName is like 'ssac_cognito_stack_dev_IdentityPool',
        // this may be to do with IdentityPool naming rules
        IdentityPool: [`${projectCode}-cognito-stack-${stage}-IdentityPool`],
    },
    // DynamoDB_OLD: {
    //   name: `${projectCode}-main-table-${stage}`,
    //   arn: `arn:aws:dynamodb:${region}:${accountId}:table/${projectCode}-main-table-${stage}`
    // },
    DynamoDB: {
        name: `${projectCode}-${stage}-main-table`,
        arn: `arn:aws:dynamodb:${region}:${accountId}:table/${projectCode}-${stage}-main-table`,
    },
    EventBridge: {
        scheduler: {
            arn: `arn:aws:scheduler:${region}:${accountId}`,
        },
    },
    Glue: {
        /** 2026 01 - the old single dump database */
        BIReadingsDatabase: {
            name: 'readings',
            Tables: {
                BusinessData: { name: 'business_objects', },
                BusinessContext: { name: 'business_context', s3Folder: 'readings/business-objects' },
                EntityReadings: { name: 'entity_readings', s3Folder: 'readings/entity-readings' },
            }
        },
        NetworkDataDatabase: {
            name: 'network',
            Tables: {
                Device: { name: 'device', s3Folder: 'network/device' },
                Gateway: { name: 'gateway', s3Folder: 'network/gateway' },
                GatewayMetrics: { name: 'gateway-metrics', s3Folder: 'metrics/gateway' }
            }
        },
        /** 2026 01 - the new entity readings database */
        EntityReadingsDatabase: {
            name: 'entity',
            Tables: {
                Device: { name: 'readings', s3Folder: 'entity' },
            }
        },
        Assets: {
            etlScripts: {
                s3Folder: 'scripts/etl'
            }
        }
    },
    IOT: {},
    Kinesis: {
        MainLogStream: {
            name: `${projectCode}-${stage}-logStream`,
            arn: `arn:aws:kinesis:${region}:${accountId}:stream/${projectCode}-${stage}-logStream`,
        },
    },
    LambdaLayer: {
        datastore: {
            name: `${projectCode}-${stage}-DatastoreLayer`,
        },
    },
    Lambda: (0, exports.LambdaServiceDefinition)(),
    SNS: {
        /** UNDER DEPRECATION - replaced by SQS queue */
        systemAlerts: {
            name: `${projectCode}-${stage}-systemAlerts`,
        },
        apnsPushTopic: {
            name: `${projectCode}-${stage}-APNS`,
        },
        firebasePushTopic: {
            name: `${projectCode}-${stage}-Firebase`,
        },
    },
    SQS: {
        deadLetters: {
            name: `${projectCode}-${stage}-deadLetters`,
        },
        deadLettersFifo: {
            name: `${projectCode}-${stage}-deadLetters.fifo`,
        },
        datalifecycleQueue: {
            name: `${projectCode}-${stage}-DatalifecycleQueue`,
        },
        deviceControlQueue: {
            name: `${projectCode}-${stage}-DeviceControlQueue`,
        },
        deviceControlFifoQueue: {
            name: `${projectCode}-${stage}-DeviceControlQueue.fifo`,
        },
        deviceTransactionQueue: {
            name: `${projectCode}-${stage}-DeviceTransactionQueue`,
        },
        deviceTransactionFifoQueue: {
            name: `${projectCode}-${stage}-DeviceTransactionQueue.fifo`,
        },
        entityState: {
            name: `${projectCode}-${stage}-entityState`,
        },
        networkDataIngestion: {
            name: `${projectCode}-${stage}-networkDataIngestion`,
        },
        networkCoverageRequests: {
            name: `${projectCode}-${stage}-networkCoverageRequests`,
        },
        sqmQueue: {
            name: `${projectCode}-${stage}-sqmQueue.fifo`,
        },
        subscriberNotification: {
            name: `${projectCode}-${stage}-subscriber-notification-queue`,
        },
        systemAlertsFifo: {
            name: `${projectCode}-${stage}-systemAlerts.fifo`,
        },
        notificationEmit: {
            name: `${projectCode}-${stage}-notification-emit-queue`,
        },
        thingAlertsFifo: {
            name: `${projectCode}-${stage}-ThingAlerts.fifo`,
        },
        wideawakeNWQueue: {
            name: `${projectCode}-${stage}-Wideawake-NW`,
        },
        ioStatus: {
            name: `${projectCode}-${stage}-IO-status`,
        },
        ioQueue: {
            name: `${projectCode}-${stage}-IO.fifo`,
        },
    },
    LogGroups: {
        logsDownlinkControlCloudwatch: {
            name: `${projectCode}-${stage}-logs-device-control`,
        },
        logsConsumerActions: {
            name: `${projectCode}-${stage}-logs-consumer-actions`,
        },
    },
    S3: {
        athena_glue: {
            name: `${projectCode}-${stage}-athena-glue`,
        },
        athena_results: {
            name: `${projectCode}-${stage}-athena-results`,
        },
        broadcastSchedules: {
            name: `${projectCode}-${stage}-broadcast-schedules`,
        },
        dlc_deletions: {
            name: `${projectCode}-${stage}-datalifecycle-deletions`,
        },
        dlc_large_objects: {
            name: `${projectCode}-${stage}-datalifecycle-large-objects`,
        },
        // under deprecated, usage reference removed from DataLifecycleStack, definition to be removed from BaseResources/S3 after DLC deployed to each env
        // remove bucket manually after deployment. Also to remove manually: payloads, networkData, logsDownlinkControl
        dlc_networkData: {
            name: `${projectCode}-${stage}-datalifecycle-network-data`,
        },
        dlc_ttl_expired: {
            name: `${projectCode}-${stage}-datalifecycle-ttl-expired`,
        },
        device_control_downlinks: {
            name: `${projectCode}-${stage}-device-control-downlinks`,
        },
        entity_readings: {
            name: `${projectCode}-${stage}-entity-readings`,
            path: {
                entity: 'entity'
            }
        },
        network_data_logs: {
            name: `${projectCode}-${stage}-network-data-logs`,
            path: {
                gateway: 'gateway',
                device: 'device',
                metrics: {
                    gateway: 'metrics/gateway',
                    device: 'metrics/device',
                    lns: 'metrics/lns'
                }
            }
        },
        emu: {
            name: `${projectCode}-${stage}-ui-emu`,
        },
        io_jobs: {
            name: `${projectCode}-${stage}-io-jobs`,
        },
        logsMainBucket: {
            name: `${projectCode}-${stage}-logs-main`,
        },
        networkCoverageReports: {
            name: `${projectCode}-${stage}-network-coverage`,
        },
        serviceDataBucket: {
            name: `${projectCode}-${stage}-service-data`,
            path: {
                wideawake: 'wideawake',
                deployments: 'deployments',
                systemOperation: 'system/operation',
                systemDatastoreItems: 'system/datastoreItems'
            }
        },
        sqsDeadLetters: {
            name: `${projectCode}-${stage}-sqs-dead-letters`,
        },
        timestream: {
            name: `${projectCode}-${stage}-timestream`,
        },
        uiV2: {
            name: `${projectCode}-${stage}-ui-version-2`,
        },
        uiV3: {
            name: `${projectCode}-${stage}-ui-version-3`,
        },
        userBlobs: {
            name: `${projectCode}-${stage}-userblobs`,
        },
    },
};
/**
 * 22 07 31 Only functions with defined alarms
 * @param functionName
 * @returns
 */
const getLambdaAlarms = (functionName) => {
    let res = undefined;
    const lambdaServiceDefinitionEntry = Object.entries((0, exports.LambdaServiceDefinition)()).find(([k, sd]) => sd.name === functionName);
    if (lambdaServiceDefinitionEntry) {
        const [lambdaName, sd] = lambdaServiceDefinitionEntry;
        if (sd.alarmConfig) {
            res = {
                ...exports.defaultLambdaAlarms,
                ...sd.alarmConfig,
            };
        }
        else {
            console.log(`${lambdaName} has no configured alarms, using default`);
        }
    }
    else {
        console.log(`no service definition for ${functionName}`);
        //res = defaultLambdaAlarms
    }
    return res;
};
exports.getLambdaAlarms = getLambdaAlarms;
